import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldId } from '@gk/gk-modules';
import { map, Observable } from 'rxjs';
import { WorkspaceStateId } from './request-workspace-state.model';

@Injectable()
export class RequestWorkspaceStateService {
  constructor(private httpClient: HttpClient) {}

  updateWorkspaceState<T>(
    workspaceState: WorkspaceStateId,
    value: T,
    requestMode?: FieldId,
  ): Observable<void> {
    return this.httpClient.post<void>('/api/system/euslugi/cache/draft', {
      Type: workspaceState,
      Version: requestMode,
      Value: JSON.stringify(value),
    });
  }

  getWorkspaceState<T>(
    workspaceState: WorkspaceStateId,
    requestMode?: FieldId,
  ): Observable<T> {
    return this.httpClient
      .get<string>(
        `/api/system/euslugi/cache/draft/${workspaceState}${requestMode ? `/${requestMode}` : ''}`,
      )
      .pipe(map((value) => JSON.parse(value)));
  }
}
